export default "__VITE_ASSET__B2lQGAGF__"